export default __webpack_public_path__ + "static/media/Tanzende-Schweine.12ef1f68.webp";